import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "YOUR_API_KEY",
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "YOUR_PROJECT.firebaseapp.com",
    databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || "https://YOUR_PROJECT-default-rtdb.firebaseio.com",
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "YOUR_PROJECT_ID",
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "YOUR_PROJECT.appspot.com",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "YOUR_SENDER_ID",
    appId: import.meta.env.VITE_FIREBASE_APP_ID || "YOUR_APP_ID"
};
export const isConfigured = firebaseConfig.apiKey !== "YOUR_API_KEY" || firebaseConfig.databaseURL !== "https://YOUR_PROJECT-default-rtdb.firebaseio.com";

export const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const googleProvider = new GoogleAuthProvider();
export const isDevelopment = import.meta.env.DEV || import.meta.env.VITE_APP_ENV === 'development';
export const DB_PREFIX = isDevelopment ? 'dev/' : '';

export const _cache = new Map();
export const CACHE_TTL = {
    userByEmail: 2 * 60 * 1000,       // 2 minutes
    userByUsername: 2 * 60 * 1000,    // 2 minutes
    hiringManagerProfile: 3 * 60 * 1000, // 3 minutes
    userCredits: 60 * 1000,           // 1 minute
    organization: 5 * 60 * 1000,      // 5 minutes
    teamMembers: 3 * 60 * 1000,       // 3 minutes
    candidateList: 5 * 60 * 1000,       // 5 minutes
    blockedEmails: 15 * 60 * 1000,
    businesses: 5 * 60 * 1000,
    reviews: 3 * 60 * 1000,
    trackerItems: 2 * 60 * 1000,
    threadPosts: 2 * 60 * 1000,
    techStack: 10 * 60 * 1000,
    faq: 10 * 60 * 1000,
    jobs: 3 * 60 * 1000,
    embeddings: 15 * 60 * 1000,
    hotThreads: 5 * 60 * 1000,
    preregistrations: 5 * 60 * 1000,
    userResumes: 5 * 60 * 1000,
    coverLetters: 5 * 60 * 1000,
    generalThreadPosts: 5 * 60 * 1000,
};



export function cacheGet(key) {
    const entry = _cache.get(key);
    if (!entry) return undefined;
    if (Date.now() - entry.ts > entry.ttl) {
        _cache.delete(key);
        return undefined;
    }
    return entry.value;
}

export function cacheSet(key, value, ttl) {
    _cache.set(key, { value, ts: Date.now(), ttl });
}

/** Invalidate cache entries whose key starts with the given prefix */
export function invalidateCache(prefix) {
    for (const key of _cache.keys()) {
        if (key.startsWith(prefix)) _cache.delete(key);
    }
}